import {AdminUserActionTypes} from "./adminUser.types";

const INITIAL_STATE = {
  adminUsers: undefined,
};

const adminUserReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AdminUserActionTypes.SET_ADMIN_USERS:
      return {
        ...state,
        adminUsers: action.payload,
      };
    default:
      return state;
  }
};

export default adminUserReducer;